<template>
  <button
    v-tooltip="$t('team_mode.share_document')"
    v-bind="$attrs"
    class="rounded p-1 transition hover:bg-gray-200"
    :class="{
      'bg-lexmea-selection-lightest': schema.is_shared,
    }"
    title="$t('team_mode.share_document')"
    @click="modalOpen = true"
  >
    <SharedSchemaIcon
      :shared="true"
      className="size-5"
      colorClass="text-black"
      arrowColor="text-black"
    />
  </button>
  <LexmeaModal v-model="modalOpen" contentClass="w-96">
    <template #title>
      {{ $t("team_mode.share_document") }}
    </template>
    <template #default>
      <ShareSchemaForm :schema="schema" @close="modalOpen = false" />
    </template>
  </LexmeaModal>
</template>

<script setup lang="ts">
import type { ISchema } from "~/models/IUserEntry";

defineOptions({
  inheritAttrs: false,
});

defineProps<{
  schema: ISchema;
}>();

const modalOpen = ref(false);
</script>
